module.exports = __webpack_public_path__ + "img/copy.24bca28f.svg";